import { useTranslation } from "react-i18next";
import { Space, Text } from "melco-ui";
import { SortableList } from "../../shared/SortableList";
import { useFontsSorting } from "../../../hooks/libraries/fontCollections/useFontsSorting";
import { FontsListThumbnail } from "../fonts/FontsListThumbnail";

export const FontsSortableList: React.FC = () => {
  const { t } = useTranslation();
  const [fonts, reorderFonts] = useFontsSorting();

  return (
    <div data-cy-id="fonts-sortable-list-wrapper">
      <Space direction="vertical" size="small">
        <Text>
          {t("libraries.font_collections.detail.sort_sider.subtitle")}
        </Text>
        <SortableList
          items={fonts}
          onSortingChange={reorderFonts}
          renderItem={(font) => {
            return <FontsListThumbnail font={font} />;
          }}
        />
      </Space>
    </div>
  );
};
